import React from "react";
import { makeStyles } from "@material-ui/styles";
import { CardContent, Typography, Card, Grid, CardHeader } from "@material-ui/core";

export default function NewsCard ({ data }) {
  const classes = useStyles();

  return (
    <>
    {data && data.length > 0 ?
      data.map((e) => (
      <Card className={classes.infoCardView}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className={classes.infoGrid}>
            <CardHeader title={e.title} />
            <CardContent>
              <Typography 
                className={classes.infoDescription} 
                component={'h2'}
                dangerouslySetInnerHTML={{ __html: e.content }}
              />
            </CardContent>
          </Grid>
        </Grid>
      </Card>
      ))
      :
      <></>
    }
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  infoCardView: {
    marginBottom: 24,
    boxShadow: '0px 2px 10px #e5e9f2',
    '& span' : {
      fontFamily: 'Proxima Nova, sans-serif !important',
      color: `${theme.palette.primary.primaryColor} !important`,
    },
    '& .MuiCardContent-root': {
      padding: 0,
    },
    '& .MuiGrid-spacing-xs-3': {
      width: '100% !important',
    },
    '& .MuiCardHeader-root': {
      paddingBottom: '24px !important',
      paddingLeft: '0px !important',
      paddingRight: '0px !important',
    }
  },
  infoGrid: {
    paddingTop: '24px !important',
    paddingRight: '12px !important',
    paddingBottom: '24px !important',
    paddingLeft: '36px !important',
  },
  infoDescription: {
    fontSize: 14,
  },
}))
